import { graphql } from 'react-relay';

export const otherDocumentsFragment = graphql`
    fragment OtherDocuments_documentLabels on DocumentLabels {
        labels {
            key
            label
            shortlabel
        }
        documentLabelsTitle
        furtherDocumentLabelsTitle
        allDocumentLabelsTitle
    }
`;
